import { createSlice } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { noteThunks } from './noteThunks';
import type { NoteState } from './noteTypes';

const initialState: NoteState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  totalCount: 0,
};

export const noteSlice = createSlice({
  name: 'notes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addCrudCases(builder, noteThunks, (n) => n.noteId);
  },
});

export const noteReducer = noteSlice.reducer;
